import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-person-remove-sharp",
  "use": "icon-person-remove-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-person-remove-sharp\"><title>Person Remove</title><path d=\"M16 214h144v36H16z\" /><circle cx=\"288\" cy=\"144\" r=\"112\" /><path d=\"M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol